export default function printReportCollaborator(name, startDate, endDate, idEmployee = "") {
  const token = localStorage.getItem("token");

  if (name === "Colaborador") {
    return printAllEmployee(token)
  }
  if (name === "LucroPorColaborador") {
    return printAllEmployeeProfit(token, startDate, endDate, idEmployee)
  }

}

function printAllEmployee(token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/employees/report/all/employee/print/?auth=${token}`
  );
}

function printAllEmployeeProfit(token, startDate, endDate, idEmployee) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/employees/report/all/employee/print/profit?auth=${token}&name=employee&type=&startDate=${startDate}&endDate=${endDate}&finishing=true&idFuncionario=${idEmployee}`
  );
}
